import React from "react";
import { FiBookOpen, FiCalendar, FiMapPin, FiUser, FiInfo } from "react-icons/fi";
import StudentClassSchedule from "./StudentClassSchedule";

const displayText = (value, fallback = "—") => {
  if (!value) return fallback;
  if (typeof value === "string") return value;
  if (typeof value === "object") return value.vi || value.en || fallback;
  return String(value);
};

function InfoRow({ icon, label, value }) {
  return (
    <div className="rounded-xl border bg-slate-50 p-4">
      <div className="flex items-center gap-2 text-sm font-medium text-slate-500">
        {icon} {label}
      </div>
      <div className="mt-1 font-semibold text-slate-900">{value || "—"}</div>
    </div>
  );
}

export default function StudentClassInfo({ classInfo, program }) {
  if (!classInfo) {
    return (
      <div className="rounded-2xl border bg-white p-5 text-slate-600">
        Chọn một lớp để xem thông tin chi tiết.
      </div>
    );
  }

  const teachers = Array.isArray(classInfo.teachers) && classInfo.teachers.length
    ? classInfo.teachers.map((t) => t.display?.name || t.display?.email || t.uid || t.id).join(", ")
    : "Chưa cập nhật";

  const programName = displayText(program?.name || program?.title || program?.level || classInfo.programName || classInfo.programId);

  return (
    <div className="space-y-4">
      <div className="grid md:grid-cols-2 gap-4">
        <InfoRow icon={<FiBookOpen />} label="Chương trình" value={programName} />
        <InfoRow icon={<FiUser />} label="Giáo viên" value={teachers} />
        <InfoRow icon={<FiMapPin />} label="Phòng học" value={classInfo.room || "Chưa cập nhật"} />
        <InfoRow icon={<FiInfo />} label="Trạng thái" value={classInfo.status === "inactive" ? "Ngừng hoạt động" : "Đang hoạt động"} />
        <InfoRow icon={<FiCalendar />} label="Ngày bắt đầu" value={classInfo.startDate || "—"} />
        <InfoRow icon={<FiCalendar />} label="Ngày kết thúc" value={classInfo.endDate || "—"} />
      </div>

      {classInfo.description && (
        <div className="rounded-2xl border bg-white p-5">
          <div className="font-semibold text-slate-900 mb-2">Mô tả lớp học</div>
          <p className="text-slate-700 whitespace-pre-line">{displayText(classInfo.description)}</p>
        </div>
      )}

      <StudentClassSchedule schedule={classInfo.schedule} />
    </div>
  );
}
